var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18 0c9.9411255 0 18 8.0588745 18 18s-8.0588745 18-18 18S0 27.9411255 0 18 8.0588745 0 18 0zm7.0035204 10.6751264L9.32347945 17.8312653c-.08441612.0385402-.13877682.1212687-.13980598.2126831-.0010003.0914143.05157253.175282.1351672.2155784l4.43742743 2.1390766c.0813719.0392522.1783997.0303766.2510739-.0229722l4.3144031-3.1674169-3.3869854 3.422105c-.0483206.0488398-.0729642.1157156-.0676489.1835881l.3372296 4.3138933c.0074897.0955911.0727225.1773229.1654498.2072722.0247885.0079739.0502534.0118659.0754285.0118659.0690502 0 .1362158-.029095.1829419-.0822539l2.3552436-2.680823 2.9115589 1.3664688c.0632033.0296646.1363608.0308987.2005789.0034649.0642181-.0274813.1131185-.080925.1340897-.1465193l4.1061896-12.8458037c.0287024-.0897057.0007248-.1875276-.0711763-.2495147-.0719494-.0619871-.1743408-.0763685-.2611246-.0368315z",
    id: "a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.ceada5789ea9e40407c764df8d9cf111.svg";
export { ForwardRef as ReactComponent };